import axios from 'axios';

export default {
  login: (url:string, body:string, options:{}) => axios
    .post(url, body, options )
    .then(
      (response => {
        return response
      }),
      (error) => {
        return error.response
      }
    ),

  logout: (url:string, body:string, options:{}) => axios
      .post(url, body, options )
      .then(
        (response => {
          return response
        }),
        (error) => {
          return error.response
        }
      ),

  refreshToken: (url:string, body:string, options:{}) => axios
      .post(url, body, options)
      .then(
        (response => {
          return response
        }),
        (error) => {
          return error.response
        }
      ),

  setPassword: (url:string, body:{}, options:{} ) => axios
      .post(url,body,options)
      .then(
        (response => {
          return response
        }),
        (error) => {
          return error.response
        }
      ),

  changePassword: (url:string, body:{}, options:{} ) => axios
      .post(url,body,options)
      .then(
        (response => {
          return response
        }),
        (error) => {
          return error.response
        }
      ),

  requestWelcomeMail: (url:string, body:{}, options:{} ) => axios
      .post(url,body,options)
      .then(
        (response => {
          return response
        }),
        (error) => {
          return error.response
        }
      )

  };




